import { memo } from 'react';

import { usePrefetchConversations } from '../../hooks/usePrefetchConversations';

// Renders nothing; isolates the prefetch subscriptions from Nav, in both directions.
export const ConversationsPrefetcher = memo(() => {
  usePrefetchConversations();

  return null;
});

ConversationsPrefetcher.displayName = 'ConversationsPrefetcher';
